import {Component, EventEmitter, Input, Output} from '@angular/core';
import {SortDirection, TableColumn} from '../ace-table.component';
import {I18nMessage} from '@app/shared/api/model/i18n';

@Component({
  selector: 'app-ace-table-default-header',
  templateUrl: './ace-table-default-header.component.html',
  styleUrls: ['./ace-table-default-header.component.scss'],
  standalone: false
})
export class AceTableDefaultHeaderComponent {
  readonly SortDirection = SortDirection;
  @Input() column: TableColumn;
  @Input() sortDir: SortDirection;
  @Input() title: string | I18nMessage;
  @Input() titleTooltip: I18nMessage | null = null;
  @Input() disabled = false;
  @Output() sortChange: EventEmitter<MouseEvent> = new EventEmitter();

  triggerSort(mouseEvent: MouseEvent): void {
    mouseEvent.preventDefault();
    if (!this.disabled) {
      this.sortChange.emit(mouseEvent);
    }
  }
}
